import React from 'react'
import classnames from 'classnames'

import './ToggleSwitch.scss'

interface ToggleSwitchProps {
  readonly id: string
  readonly checked: boolean
  readonly label?: string
  readonly disabled?: boolean
  onChange(newChecked: boolean): void
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = props => {
const { id, checked, label, disabled } = props

const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  if (disabled) { return }

  props.onChange(e.target.checked)
}

  return (
    <div
      className={classnames(
        'ToggleSwitch',
        { 'ToggleSwitch__disabled': disabled },
      )}
    >
      <input
        type="checkbox"
        className="ToggleSwitch__checkbox"
        id={id}
        checked={checked}
        onChange={handleOnChange}
      />
      <label className="ToggleSwitch__label" htmlFor={id}>
        <span className="ToggleSwitch__inner" />
        <span className="ToggleSwitch__switch" />
      </label>
      {label && <label htmlFor={id} className="ToggleSwitch__label-text">{label}</label>}
    </div>
  )
}

export default ToggleSwitch
